import React from 'react';
function TableCellJsx(prop) {
    const { renderJsx, record, value, index, _context } = prop || {};
    return React.createElement("div", null, renderJsx?.(record, value, index, _context));
}
TableCellJsx.displayName = 'TableCellJsx';
export { TableCellJsx };
